/**
 * @fileoverview Modal component for viewing SAP movement details
 * Displays material movement information in a read-only view
 */
import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { intl, fetchData, HTTP_STATUS } from "dmsbasereact";
import { DmsDetailModal } from "../../DmsDetailModal";
import { ViewModeContent } from "./ViewModeContent";

/**
 * Modal for viewing SAP movement details (read-only)
 */
export const SapMovementDetailModal = ({
  open,
  onClose,
  movement = null}) => {
  const [loading, setLoading] = useState(false);
  const [enrichedMovement, setEnrichedMovement] = useState(null);

  // Load additional movement data if needed
  const loadAdditionalData = useCallback(async (movementData) => {
    if (!movementData) return null;

    try {
      // Fetch full movement details
      const response = await fetchData(
        `/sap-movement/${movementData.pk}`,
        "GET",
        true
      );
      
      if (response.status === HTTP_STATUS.OK_200 && response.data?.data) {
        return response.data.data;
      }
    } catch (error) {
      console.error("Error loading movement details:", error);
    }

    return movementData;
  }, []);

  // Load data when modal opens or movement changes
  useEffect(() => {
    if (open && movement) {
      setLoading(true);
      loadAdditionalData(movement).then((enriched) => {
        setEnrichedMovement(enriched);
        setLoading(false);
      });
    } else if (!open) {
      setEnrichedMovement(null);
    }
  }, [open, movement, loadAdditionalData]);

  return (
    <DmsDetailModal
      open={open}
      onClose={onClose}
      data={enrichedMovement}
      loading={loading}
      title={{
        view: intl.get("SapMovementDetails").d("SAP Movement Details"),
      }}
      viewContent={ViewModeContent}
      canEdit={false}
      editContent={() => null}
      prepareFormData={(data) => data}
      onSave={() => {}}
    />
  );
};

SapMovementDetailModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  movement: PropTypes.object,
};

